import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetSweepstakesByGroupId = (groupId: string) => {
  const get = useTypedApiClient({
    path: '/le-connect/contests/groupId/{groupId}',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/contests/groupId', groupId],
    queryFn: async () => {
      const { data } = await get({ groupId })
      return data
    },
  })
}
